import { render, staticRenderFns } from "./initializeData.vue?vue&type=template&id=4a1ee662&"
import script from "./initializeData.vue?vue&type=script&lang=js&"
export * from "./initializeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports